'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _RotateRightOutlined = _interopRequireDefault(require('./lib/icons/RotateRightOutlined'));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

var _default = _RotateRightOutlined;
exports.default = _default;
module.exports = _default;